import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import ElementPlus from 'element-plus';
// import 'element-plus/lib/theme-chalk/index.css';
import { Anchor, Carousel, Input, Select, Radio, Checkbox, BackTop, Drawer } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import * as Icons from "@ant-design/icons-vue";
import $http from "./httprequest/index"
// import Vant from 'vant';
// import 'vant/lib/index.css';
const icons = Icons
const app = createApp(App)
app.use(store).use(router).use(Anchor).use(BackTop).use(Carousel).use(Drawer).use(Input).use(Select).use(Radio).use(Checkbox).mount('#app')
for (const i in icons) {
    // console.log(i)
    app.component(i, icons[i]);
}
app.config.globalProperties.$http = $http;
